import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=c7f4366e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7f4366e')) {
      api.createRecord('c7f4366e', component.options)
    } else {
      api.reload('c7f4366e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=c7f4366e&", function () {
      api.rerender('c7f4366e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CryTmaWByxsG/JS/comp/stardisplay.vue"
export default component.exports